import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController, IonicApp } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { ChangePasswordPage } from '../pages/change-password/change-password';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  pages: Array<{ title: string, component: any }>;
  status: string;

  constructor(public platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private FireAuth: AngularFireAuth, private fire: AngularFirestore, public alertCtrl: AlertController, public ionicApp: IonicApp) {
    platform.ready().then(() => {
      this.isLoggedIn();
      statusBar.styleDefault();
      this.setupBackButtonBehavior();
      splashScreen.hide();
      this.pages = [
        { title: 'Inicio', component: HomePage }
      ];
    });
  }

  openPage(page) {
    this.nav.setRoot(page.component);
  }

  isLoggedIn() {
    this.FireAuth.authState.subscribe(res => {
      if (!(res && res.uid)) {
        this.nav.setRoot(LoginPage);
      }
      else {
        this.nav.setRoot(HomePage).then(() => {
          this.msjInitial();
        });
      }
    });
  }

  logout() {
    this.FireAuth.auth.signOut().then(() => { });
  }

  msjInitial() {
    if (this.FireAuth && this.FireAuth.auth && this.FireAuth.auth.currentUser && this.FireAuth.auth.currentUser.uid) {
      this.fire.doc("Users/" + this.FireAuth.auth.currentUser.uid).ref.get().then(document => {
        if (document.exists) {
          if (document.get('isNewUser') == true) {
            let alert = this.alertCtrl.create({
              title: 'Usuario nuevo',
              subTitle: 'Te invitamos a cambiar tu contraseña en tu perfil de usuario.',
              buttons: [{
                text: 'Ok',
                role: 'cancel',
                handler: () => {
                  this.nav.setRoot(ChangePasswordPage, { parent: 'inicio' });
                }
              }],
            });
            alert.present();
          }
        }
      }).catch(error => {
        //console.error(error);
      });
    }
  }

  private setupBackButtonBehavior() {
    if (this.platform.is("core") || this.platform.is("mobileweb")) {
      window.onpopstate = (evt) => {
        let activePortal = this.ionicApp._loadingPortal.getActive() || this.ionicApp._modalPortal.getActive() || this.ionicApp._toastPortal.getActive() || this.ionicApp._overlayPortal.getActive();
        if (activePortal) {
          activePortal.dismiss();
          return;
        }
        if (!this.nav.canGoBack()) {
          this.nav.setRoot(HomePage);
        }
      };
      this.nav.viewDidEnter.subscribe((app) => {
        history.pushState(null, null, "");
      });
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts